import React, { Component } from 'react';
import teaLoading from './loading.gif';
const loadingStyle = {
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    backgroundColor: '#eee'
  },
  teaLoading: {
    width: '1.2rem',
    height: '1.2rem',
    backgroundImage: 'url(' + teaLoading + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    backgroundPosition: 'center center',
    marginTop: '-1.5rem'
  },
  loadingdesc: {
    marginTop: '0.1rem',
    color: '#0a1d70'
  }
};
class LuckLazy extends Component {
  render() {
    return (
      <div style={loadingStyle.container}>
        <div style={loadingStyle.teaLoading}></div>
        <div style={loadingStyle.loadingdesc}>加载中...</div>
      </div>
    );
  }
}
export default LuckLazy;
